import { type EidCategories } from '@app/client/common/structs/emoji/emoji';
import { type Organization, type OrganizationBranding } from '@app/client/common/structs/organizations/organizations';

export const ACTION_SET_WALLET_DATA = 'ACTION_SET_WALLET_DATA';
export const ACTION_SET_ORGANIZATION = 'ACTION_SET_ORGANIZATION';
export const ACTION_SET_WALLET_LINK_SUCCESS = 'ACTION_SET_WALLET_LINK_SUCCESS';
export const ACTION_SET_WALLET_ADDRESSES = 'ACTION_SET_WALLET_ADDRESSES';
export const ACTION_SET_PARTNER_CONVERSION_ID = 'ACTION_SET_PARTNER_CONVERSION_ID';
export const ACTION_SET_ADDRESS_STRING = 'ACTION_SET_ADDRESS_STRING';
export const ACTION_RESET_PARTNER_INTEGRATIONS_STORE = 'ACTION_RESET_PARTNER_INTEGRATIONS_STORE';

export type WalletDataType = OrganizationBranding;

export interface WalletAddressData {
    address: string;
    name: string;
    type: string;
}

export interface PartnerIntegrationsState {
    walletData?: WalletDataType;
    appCurrencyTags: string[];
    organization?: Organization | null;
    linkSuccess: boolean;
    walletAddresses: EidCategories[];
    walletAddressTypes: string[];
    walletAddressData: WalletAddressData[];
    partnerConversionId: string;
}

interface SetWalletDataAction {
    type: typeof ACTION_SET_WALLET_DATA;
    walletData: WalletDataType;
}

interface SetOrganizationAction {
    type: typeof ACTION_SET_ORGANIZATION;
    organization: Organization;
}

interface SetWalletLinkSuccessAction {
    type: typeof ACTION_SET_WALLET_LINK_SUCCESS;
    linkSuccess: boolean;
}

interface SetWalletAddressesAction {
    type: typeof ACTION_SET_WALLET_ADDRESSES;
    walletAddresses: EidCategories[];
    walletAddressData?: WalletAddressData[];
}

interface SetAddressStringAction {
    type: typeof ACTION_SET_ADDRESS_STRING;
    walletAddresses: EidCategories[];
}

interface SetPartnerConversionId {
    type: typeof ACTION_SET_PARTNER_CONVERSION_ID;
    partnerConversionId: string;
}

interface ResetPartnerIntegrationStoreAction {
    type: typeof ACTION_RESET_PARTNER_INTEGRATIONS_STORE;
}

export type PartnerIntegrationActionTypes =
    | SetWalletDataAction
    | SetOrganizationAction
    | SetWalletLinkSuccessAction
    | SetWalletAddressesAction
    | SetPartnerConversionId
    | SetAddressStringAction
    | ResetPartnerIntegrationStoreAction;
